import type { UseFormGetFieldState } from 'react-hook-form';

import type {
  PatchedTripWrite,
} from 'src/common/external/bambi-api/tripsApi';

import type { AddTripFormValues } from '../FormValues';
import { buildExistingTripPayload } from './adaptFormValuesHelpers';

export const adaptFormValuesToUpdate = (
  formValues: AddTripFormValues,
  getFieldState: UseFormGetFieldState<AddTripFormValues>
): PatchedTripWrite => {
  const tripUpdate: PatchedTripWrite = buildExistingTripPayload(
    formValues.trips[0],
    formValues
  );

  // Check dirty on the following fields so as to not cause a recalcuation
  // pickup, dropoff, scheduled_pickup_at

  if (!getFieldState('trips.0.pickupLocation').isDirty) {
    delete tripUpdate.pickup;
  }

  if (!getFieldState('trips.0.dropoffLocation').isDirty) {
    delete tripUpdate.dropoff;
  }

  if (
    !getFieldState('trips.0.timing.date').isDirty &&
    !getFieldState('trips.0.timing.pickup_time').isDirty
  ) {
    delete tripUpdate.scheduled_pickup_at;
  }

  return tripUpdate;
};
